import React, { PureComponent } from 'react';

import classNames from 'classnames';
import { TableBody, TableRow, TableCell } from 'components/table';
import PropTypes from 'prop-types';

import DataTableContext from './DataTableContext';

class DataTableBody extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
  };

  render() {
    const { children, className } = this.props;
    const classComponent = classNames('data-table-body', className);

    return (
      <TableBody className={classComponent}>
        {children ? children : this.renderDefault()}
      </TableBody>
    );
  }

  renderDefault() {
    return (
      <DataTableContext.Consumer>
        {({ actions, data }) =>
          data.items.map((item) => (
            <TableRow
              key={item.id}
              onClick={actions.onRowClick && (() => actions.onRowClick(item))}
            >
              {data.columns.map((column) => (
                <TableCell
                  key={column.value}
                  columnName={column.label}
                  onClick={
                    actions.onCellClick &&
                    (() => actions.onCellClick(item, column))
                  }
                >
                  {item[column.name]}
                </TableCell>
              ))}
            </TableRow>
          ))
        }
      </DataTableContext.Consumer>
    );
  }
}

export default DataTableBody;
